<template>
  <div class="c-app">
    <CWrapper fluid>
      <TheHeader @logout="logout"></TheHeader>
      <loading :active.sync="isLoading"></loading>
      <div class="c-body">
        <main class="c-main">
          <transition name="fade" mode="out-in">
            <router-view @logout="logout"></router-view>
          </transition>
        </main>

        <CContainer class="pt-5" fluid>
          <CRow>
            <CCol lg="6" md="12">
              <CCard class="custom-card">
                <CCardHeader>
                  Vehicle Plate Recognition
                </CCardHeader>
                <CCardBody class="p-3">
                  <CRow>
                    <CCol>
                      <b-form-group
                        label="Plate Image" 
                        label-for="image-upload">
                        <b-form-file
                          id="image-upload"
                          v-model="plateImage.value"
                          placeholder="Choose an image or drop it here..."
                          drop-placeholder="Drop image here..."
                          @change="changePlateImage"
                        ></b-form-file>
                      </b-form-group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b-form-group
                        label="Sort by"
                        label-for="sort-by"
                      >
                        <b-form-select
                          id="sort-by"
                          v-model="sortPlateBy" 
                          :options="sortOptions"
                        ></b-form-select>
                      </b-form-group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol lg="4">
                      <b-form-group
                        label="Number of plates to detect"
                        label-for="plate-num"
                      >
                        <b-form-input
                          id="plate-num"
                          type="number"
                          v-model="numPlate"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b-button variant="primary" @click="uploadPlateImage">Submit</b-button>
                      <b-button class="ml-2" variant="danger" @click="resetPlate">Reset</b-button>
                    </CCol>
                  </CRow>
                  <CRow v-if="plateImageResult != null" class="mt-4" alignHorizontal="center">
                    <CCol sm="12">
                      <b-img thumbnail center :src="plateImageResult" alt="Image"></b-img>   
                    </CCol>
                  </CRow>
                  <CRow v-if="plateImageResult != null" class="mt-4" alignHorizontal="center">
                    <CCol sm="12" v-if="tablePlate.items.length != 0">
                      <b-table striped hover show-empty
                        :items="tablePlate.items"
                        :fields="tablePlate.fields"
                        :busy="!tablePlate.isLoaded"
                        :per-page="tablePlate.perPage"
                        :current-page="tablePlate.currentPage"
                      >
                        <template slot="empty">
                          <div v-if="!tablePlate.isLoaded" class="text-center">
                            <b-spinner label="Fetching Data..."></b-spinner>
                          </div> 
                          <div v-else class="text-center">
                            Tidak ada data
                          </div> 
                        </template>
                        <template #cell(index)="data">
                          {{ data.index + 1 + ((tablePlate.currentPage-1)*10) }}
                        </template>
                        <template #cell(confidence)="row">
                          <CBadge color="success" v-if="row.item.confidence > successNum">{{row.item.confidence}}%</CBadge>
                          <CBadge color="warning" v-else-if="row.item.confidence > warningNum">{{row.item.confidence}}%</CBadge>
                          <CBadge color="danger" v-else>{{row.item.confidence}}%</CBadge>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol lg="6" md="12">
              <CCard class="custom-card">
                <CCardHeader>
                  STNK Recognition
                </CCardHeader>
                <CCardBody class="p-3">
                  <CRow>
                    <CCol>
                      <b-form-group
                        label="STNK Image" 
                        label-for="stnk-image-upload">
                        <b-form-file
                          id="stnk-image-upload"
                          v-model="stnkImage.value"
                          placeholder="Choose an image or drop it here..."
                          drop-placeholder="Drop image here..."
                          @change="changeStnkImage"
                        ></b-form-file>
                      </b-form-group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b-button variant="primary" @click="uploadStnkImage">Submit</b-button>
                      <b-button class="ml-2" variant="danger" @click="resetStnk">Reset</b-button>
                    </CCol>
                  </CRow>
                  <CRow v-if="stnkImageResult != null" class="mt-4" alignHorizontal="center">
                    <CCol sm="12">
                      <b-img thumbnail center :src="stnkImageResult" alt="Image"></b-img>   
                    </CCol>
                  </CRow>
                  <CRow v-if="dataStnk.received" class="mt-4" alignHorizontal="center">
                    <CCol lg="6" sm="12">
                      <b-form-group
                        label="Nomor Registrasi"
                        label-for="no-reg"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.noReg.confidence > successNum">{{dataStnk.noReg.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.noReg.confidence > warningNum">{{dataStnk.noReg.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.noReg.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.noReg.value"
                            id="no-reg"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group
                        label="Merk"
                        label-for="merk"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.merk.confidence > successNum">{{dataStnk.merk.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.merk.confidence > warningNum">{{dataStnk.merk.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.merk.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.merk.value"
                            id="merk"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group
                        label="Jenis"
                        label-for="jenis"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.jenis.confidence > successNum">{{dataStnk.jenis.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.jenis.confidence > warningNum">{{dataStnk.jenis.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.jenis.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.jenis.value"
                            id="jenis"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Model"
                        label-for="model"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.model.confidence > successNum">{{dataStnk.model.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.model.confidence > warningNum">{{dataStnk.model.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.model.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.model.value"
                            id="model"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Tipe"
                        label-for="tipe"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.tipe.confidence > successNum">{{dataStnk.tipe.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.tipe.confidence > warningNum">{{dataStnk.tipe.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.tipe.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.tipe.value"
                            id="tipe"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </CCol>
                    <CCol lg="6" sm="12">
                      <b-form-group
                        label="Nama Pemilik"
                        label-for="nama-pemilik"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.nama.confidence > successNum">{{dataStnk.nama.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.nama.confidence > warningNum">{{dataStnk.nama.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.nama.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.nama.value"
                            id="nama-pemilik"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group
                        label="Tahun Pembuatan"
                        label-for="tahun-pembuatan"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.tahun.confidence > successNum">{{dataStnk.tahun.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.tahun.confidence > warningNum">{{dataStnk.tahun.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.tahun.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.tahun.value"
                            id="tahun-pembuatan"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group
                        label="Isi Silinder"
                        label-for="silinder"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.silinder.confidence > successNum">{{dataStnk.silinder.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.silinder.confidence > warningNum">{{dataStnk.silinder.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.silinder.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.silinder.value"
                            id="silinder"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Nomor Rangka"
                        label-for="no-rangka"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.noRangka.confidence > successNum">{{dataStnk.noRangka.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.noRangka.confidence > warningNum">{{dataStnk.noRangka.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.noRangka.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.noRangka.value"
                            id="no-rangka"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Berlaku sampai"
                        label-for="berlaku"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.berlaku.confidence > successNum">{{dataStnk.berlaku.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.berlaku.confidence > warningNum">{{dataStnk.berlaku.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.berlaku.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.berlaku.value"
                            id="berlaku"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </CCol>

                      <!-- <b-form-group
                        label="Alamat"
                        label-for="alamat"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.alamat.confidence > successNum">{{dataStnk.alamat.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.alamat.confidence > warningNum">{{dataStnk.alamat.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.alamat.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.alamat.value"
                            id="alamat"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                  
                      <b-form-group
                        label="Nomor Mesin"
                        label-for="no-mesin"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.noMesin.confidence > successNum">{{dataStnk.noMesin.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.noMesin.confidence > warningNum">{{dataStnk.noMesin.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.noMesin.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.noMesin.value"
                            id="no-mesin"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Tahun Registrasi"
                        label-for="tahun-registrasi"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.tahunReg.confidence > successNum">{{dataStnk.tahunReg.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.tahunReg.confidence > warningNum">{{dataStnk.tahunReg.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.tahunReg.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.tahunReg.value"
                            id="tahun-registrasi"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      
                      <b-form-group
                        label="Warna"
                        label-for="warna"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.warna.confidence > successNum">{{dataStnk.warna.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.warna.confidence > warningNum">{{dataStnk.warna.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.warna.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.warna.value"
                            id="warna"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Bahan Bakar"
                        label-for="bahan-bakar"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.bahanBakar.confidence > successNum">{{dataStnk.bahanBakar.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.bahanBakar.confidence > warningNum">{{dataStnk.bahanBakar.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.bahanBakar.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.bahanBakar.value"
                            id="bahan-bakar"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Warna TNKB"
                        label-for="warna-tnkb"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.warnaTnkb.confidence > successNum">{{dataStnk.warnaTnkb.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.warnaTnkb.confidence > warningNum">{{dataStnk.warnaTnkb.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.warnaTnkb.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.warnaTnkb.value"
                            id="warna-tnkb"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      
                      <b-form-group
                        label="Nomor BPKB"
                        label-for="no-bpkb"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.noBpkb.confidence > successNum">{{dataStnk.noBpkb.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.noBpkb.confidence > warningNum">{{dataStnk.noBpkb.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.noBpkb.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.noBpkb.value"
                            id="no-bpkb"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                        label="Kode Lokasi"
                        label-for="kode-lokasi"
                      >
                        <b-input-group>
                          <template #append>
                            <b-input-group-text>
                              <CBadge color="success" v-if="dataStnk.kodeLokasi.confidence > successNum">{{dataStnk.kodeLokasi.confidence}}%</CBadge>
                              <CBadge color="warning" v-else-if="dataStnk.kodeLokasi.confidence > warningNum">{{dataStnk.kodeLokasi.confidence}}%</CBadge>
                              <CBadge color="danger" v-else>{{dataStnk.kodeLokasi.confidence}}%</CBadge>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            v-model="dataStnk.kodeLokasi.value"
                            id="kode-lokasi"
                            :disabled="true"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </CCol> -->
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CWrapper>

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from 'vuex';
import TheHeader from '../TheHeader';
export default {
  name: 'TheContainer',
  components: {
      Loading,
      TheHeader
  },
  data(){
    return {
      plateImage: {
        name: "",
        value: null,
        blob: null
      },
      numPlate: null,
      sortPlateBy: null,
      sortOptions: [
        { value: null, text: '--Please select a sort method--', disabled: true },
        { value: "distance", text: 'Distance' },
        { value: "size", text: 'Size' },
        { value: "ratio", text: 'Distance and Size' },
      ],

      successNum: 95,
      warningNum: 49,

      stnkImage: {
        name: "",
        value: null,
        blob: null
      },

      mainProps: { height: 100 },
      plateImageResult: null,
      stnkImageResult: null,
      isLoading: false,

      tablePlate: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "vehicle_type", label: "Type", sortable: true},
          {key: "plate_number", label: "Plate Number", sortable: true},
          {key: "emblem_type", label: "Emblem", sortable: true},
          {key: "confidence", label: "Confidence", sortable: true},
        ],

        items: [],
        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      dataStnk: {
        noReg: {
          value: "",
          confidence: ""
        },
        nama: {
          value: "",
          confidence: ""
        },
        alamat: {
          value: "",
          confidence: ""
        },
        merk: {
          value: "",
          confidence: ""
        },
        tipe: {
          value: "",
          confidence: ""
        },
        jenis: {
          value: "",
          confidence: ""
        },
        model: {
          value: "",
          confidence: ""
        },
        tahun: {
          value: "",
          confidence: ""
        },
        silinder: {
          value: "",
          confidence: ""
        },
        noRangka : {
          value: "",
          confidence: ""
        },
        noMesin: {
          value: "",
          confidence: ""
        },
        warna: {
          value: "",
          confidence: ""
        },
        bahanBakar: {
          value: "",
          confidence: ""
        },
        warnaTnkb: {
          value: "",
          confidence: ""
        },
        tahunReg: {
          value: "",
          confidence: ""
        },
        // noBpkb: {
        //   value: "",
        //   confidence: ""
        // },
        // kodeLokasi: {
        //   value: "",
        //   confidence: ""
        // },
        berlaku: {
          value: "",
          confidence: ""
        },
        received: false
      },
    }
  },
  methods: {
    roundToTwo(num) {
      return +(Math.round(num + "e+2")  + "e-2");
    },

    changePlateImage(e){
      this.resetPlate()
      const name = e.target.name;
      const image = e.target.files[0];
      this.plateImage.name = image.name;

      const reader = new FileReader();
      reader.onload = e => {
        var img = new Image();
        img.onload = e => {
          // Resize the image
          var canvas = document.createElement('canvas'),
          max_size = 720,// TODO : pull max size from a site config
          width = img.width,
          height = img.height;

          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } 
          else {
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(img, 0, 0, width, height);
          var dataUrl = canvas.toDataURL('image/png');

          var BASE64_MARKER = ';base64,';
          if (dataUrl.indexOf(BASE64_MARKER) == -1) {
            var parts = dataUrl.split(',');
            var contentType = parts[0].split(':')[1];
            var raw = parts[1];

            return new Blob([raw], {type: contentType});
          }

          var parts = dataUrl.split(BASE64_MARKER);
          var contentType = parts[0].split(':')[1];
          var raw = window.atob(parts[1]);
          var rawLength = raw.length;

          var uInt8Array = new Uint8Array(rawLength);

          for (var i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }

          this.plateImage.blob = new Blob([uInt8Array], {type: contentType});
          this.plateImageResult = dataUrl          
        }
        img.src = e.target.result;
        
        // this.plateImageResult = this.plateImage.value
        // fetch(this.plateImage.value)
        // .then(res => res.blob()).then(blob => {
        //   this.plateImage.blob = blob
        // });
      };
      reader.readAsDataURL(image);   
    },

    dataURLToBlob(dataUrl) {
      var BASE64_MARKER = ';base64,';
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        var parts = dataURL.split(',');
        var contentType = parts[0].split(':')[1];
        var raw = parts[1];

        return new Blob([raw], {type: contentType});
      }

      var parts = dataURL.split(BASE64_MARKER);
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], {type: contentType});
    },

    changeStnkImage(e){
      this.resetStnk()
      const name = e.target.name;
      const image = e.target.files[0];
      this.stnkImage.name = image.name;
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e =>{
        this.stnkImage.value = e.target.result;
        this.stnkImageResult = this.stnkImage.value
        fetch(this.stnkImage.value)
        .then(res => res.blob()).then(blob => {
          this.stnkImage.blob = blob
        });
      };      
    },

    resetPlate(){
      this.plateImage = {
        name: "",
        value: null,
        blob: null
      },
      this.tablePlate.items = []
      this.plateImageResult = null
    },

    resetStnk(){
      this.stnkImage = {
        name: "",
        value: null,
        blob: null
      },
      this.stnkImageResult = null
      this.expireDate = ""
      this.stnkType = ""
      this.dataStnk = {
        noReg: {
          value: "",
          confidence: ""
        },
        nama: {
          value: "",
          confidence: ""
        },
        alamat: {
          value: "",
          confidence: ""
        },
        merk: {
          value: "",
          confidence: ""
        },
        tipe: {
          value: "",
          confidence: ""
        },
        jenis: {
          value: "",
          confidence: ""
        },
        model: {
          value: "",
          confidence: ""
        },
        tahun: {
          value: "",
          confidence: ""
        },
        silinder: {
          value: "",
          confidence: ""
        },
        noRangka : {
          value: "",
          confidence: ""
        },
        noMesin: {
          value: "",
          confidence: ""
        },
        warna: {
          value: "",
          confidence: ""
        },
        bahanBakar: {
          value: "",
          confidence: ""
        },
        warnaTnkb: {
          value: "",
          confidence: ""
        },
        tahunReg: {
          value: "",
          confidence: ""
        },
        // noBpkb: {
        //   value: "",
        //   confidence: ""
        // },
        // kodeLokasi: {
        //   value: "",
        //   confidence: ""
        // },
        berlaku: {
          value: "",
          confidence: ""
        },
        received: false
      }
    },

    uploadPlateImage() {

      let image = null

      if (this.plateImage.blob != null) {
        image = this.plateImage.blob    
      }
      else {
        return this.$helper.toastError(this, "Please upload an image!")
      }

      this.isLoading = true

      // URL builder
      let postUrl = "https://stnk.ocr.dev.inergi.id/api-plat/detect_image"

      let config = {
        headers: {
          'Content-Type':'multipart/form-data'
        }
      }

      let formData = new FormData()

      if (image != null) {
        formData.append('image', image, this.plateImage.name)
        formData.append('n_detect', parseInt(this.numPlate))
        formData.append('sort_by', this.sortPlateBy)
      }

      this.$axios.post(postUrl, formData).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            this.plateImage.value = null
            this.plateImage.blob = null
            this.tablePlate.items = []

            // if (typeof response.data.image != "undefined") this.plateImageResult = "data:image/jpeg;base64," + response.data.image
            let imagePath = response.data.image
            let imageOnly = imagePath.substring(27, imagePath.length)
            let newPath = "https://stnk.ocr.dev.inergi.id/api-plat" + imageOnly

            this.plateImageResult = newPath
            // this.plateImageResult = response.data.image
            this.tablePlate.items = response.data.data
            this.tablePlate.totalRows = response.data.data.length
            this.tablePlate.totalPages = response.data.data.length % this.tablePlate.perPage

            for (var x = this.tablePlate.items.length-1; x >= 0; x--) {
              this.tablePlate.items[x].vehicle_type = this.tablePlate.items[x].vehicle_type.charAt(0).toUpperCase() + this.tablePlate.items[x].vehicle_type.slice(1);
              this.tablePlate.items[x].confidence = (this.roundToTwo((this.tablePlate.items[x].plate_number_confidence + this.tablePlate.items[x].plate_box_confidence + this.tablePlate.items[x].vehicle_confidence + this.tablePlate.items[x].emblem_confidence) / 4)) * 100
              if (this.tablePlate.items[x].confidence < 50) {
                this.tablePlate.items.splice(x, 1)
              }
            }

            this.$helper.toastSuccess(this, "Vehicle plate recognition berhasil!")
          } else{
            this.$helper.toastError(this, "Vehicle recognition gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "Vehicle recognition gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Vehicle recognition gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Vehicle recognition gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    uploadStnkImage() {

      let image = null

      if (this.stnkImage.blob != null) {
        image = this.stnkImage.blob          
      }
      else {
        return this.$helper.toastError(this, "Please upload an image!")
      }

      this.isLoading = true

      // URL builder
      let postUrl = "https://stnk.ocr.dev.inergi.id/api-stnk/recognize_vehicle_documents"

      let config = {
        headers: {
          'Content-Type':'multipart/form-data'
        }
      }

      let formData = new FormData()

      if (image != null) {
        formData.append('image', image, this.stnkImage.name)
        formData.append('rembg', 'true')
        formData.append('resize', 'true')
        formData.append('rec_version', '1')
      }

      this.$axios.post(postUrl, formData).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            this.stnkImage.value = null
            this.stnkImage.blob = null
            let data = response.data.data

            this.dataStnk.noReg = data.nomor_registrasi
            this.dataStnk.noReg.confidence = this.roundToTwo(this.dataStnk.noReg.confidence) * 100
            this.dataStnk.nama = data.nama_pemilik
            this.dataStnk.nama.confidence = this.roundToTwo(this.dataStnk.nama.confidence) * 100
            this.dataStnk.alamat = data.alamat
            this.dataStnk.alamat.confidence = this.roundToTwo(this.dataStnk.alamat.confidence) * 100
            this.dataStnk.merk = data.merk
            this.dataStnk.merk.confidence = this.roundToTwo(this.dataStnk.merk.confidence) * 100
            this.dataStnk.tipe = data.type
            this.dataStnk.tipe.confidence = this.roundToTwo(this.dataStnk.tipe.confidence) * 100
            this.dataStnk.jenis = data.jenis
            this.dataStnk.jenis.confidence = this.roundToTwo(this.dataStnk.jenis.confidence) * 100
            this.dataStnk.model = data.model
            this.dataStnk.model.confidence = this.roundToTwo(this.dataStnk.model.confidence) * 100
            this.dataStnk.tahun = data.tahun_pembuatan
            this.dataStnk.tahun.confidence = this.roundToTwo(this.dataStnk.tahun.confidence) * 100
            this.dataStnk.silinder = data.isi_silinder
            this.dataStnk.silinder.confidence = this.roundToTwo(this.dataStnk.silinder.confidence) * 100
            this.dataStnk.noRangka = data.nomor_rangka
            this.dataStnk.noRangka.confidence = this.roundToTwo(this.dataStnk.noRangka.confidence) * 100
            this.dataStnk.noMesin = data.nomor_mesin
            this.dataStnk.noMesin.confidence = this.roundToTwo(this.dataStnk.noMesin.confidence) * 100
            this.dataStnk.warna = data.warna
            this.dataStnk.warna.confidence = this.roundToTwo(this.dataStnk.warna.confidence) * 100
            this.dataStnk.bahanBakar = data.bahan_bakar
            this.dataStnk.bahanBakar.confidence = this.roundToTwo(this.dataStnk.bahanBakar.confidence) * 100
            this.dataStnk.warnaTnkb = data.warna_tnkb
            this.dataStnk.warnaTnkb.confidence = this.roundToTwo(this.dataStnk.warnaTnkb.confidence) * 100
            this.dataStnk.tahunReg = data.tahun_registrasi
            this.dataStnk.tahunReg.confidence = this.roundToTwo(this.dataStnk.tahunReg.confidence) * 100
            // this.dataStnk.noBpkb = data.nomor_bpkb
            // this.dataStnk.noBpkb.confidence = this.roundToTwo(this.dataStnk.noBpkb.confidence) * 100
            // this.dataStnk.kodeLokasi = data.kode_lokasi
            // this.dataStnk.kodeLokasi.confidence = this.roundToTwo(this.dataStnk.kodeLokasi.confidence) * 100
            this.dataStnk.berlaku = data.berlaku_sampai
            this.dataStnk.berlaku.confidence = this.roundToTwo(this.dataStnk.berlaku.confidence) * 100
            this.dataStnk.received = true

            let imagePath = response.data.url
            let newPath = "https://stnk.ocr.dev.inergi.id/api-stnk" + imagePath

            this.stnkImageResult = newPath

            console.log(this.stnkImageResult)

            this.$helper.toastSuccess(this, "STNK recognition berhasil!")
          } else{
            this.$helper.toastError(this, "STNK recognition gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "STNK recognition gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "STNK recognition gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "STNK recognition gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    logout(){

      localStorage.removeItem(this.$tokenKeyword);
      // localStorage.removeItem(this.$tokenClockKeyword);
      localStorage.removeItem(this.$userIdKeyword);
      localStorage.removeItem(this.$userNameKeyword);
      localStorage.removeItem(this.$roleIdKeyword);
      // localStorage.removeItem(this.$roleNameKeyword);
      localStorage.clear()
      sessionStorage.clear()

      // window.removeEventListener('storage', this.dataReceived)

      this.$router.push({ name: 'Login' }).catch(()=>{})
    },

    recalculatePlate() {
      let pg = this.tablePlate.currentPage - 1

      let prev = pg * this.tablePlate.perPage + 1
      let limit = pg * this.tablePlate.perPage + this.tablePlate.perPage
      if (limit > this.tablePlate.totalRows) limit = this.tablePlate.totalRows
      if (this.tablePlate.totalRows == 0) prev = 0
      this.tablePlate.totalViewText = "Showing "+ prev + " - " + limit + " of " + this.tablePlate.totalRows + " entries"
    },
  },
  // computed: mapState(['isLoading']),
  computed: {
    totalRowsPlate() {
      return this.tablePlate.totalRows;
    },
    currentPagePlate() {
      return this.tablePlate.currentPage;
    },
  },
  watch: {

    totalRowsPlate(newVal) {
      this.recalculatePlate()
    },

    currentPagePlate(newVal) {
      this.recalculatePlate()
    },

  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
